var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    x: 23,
    y: 23,
    width: 22,
    height: 22,
    transform: "rotate(180 23 23)",
    fill: "#5E6974"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99905 11.9991C3.99905 16.4173 7.58078 19.9991 11.9991 19.9991C16.4173 19.9991 19.9991 16.4173 19.9991 11.9991C19.9991 9.88747 19.1642 7.86195 17.6774 6.36375C17.6631 6.34936 17.6488 6.33502 17.6344 6.32073C16.1362 4.83387 14.1106 3.99905 11.9991 3.99905C7.58078 3.99905 3.99905 7.58078 3.99905 11.9991ZM11.9991 15.9991C12.4409 15.9991 12.7991 15.6409 12.7991 15.1991V11.1991C12.7991 10.7572 12.4409 10.3991 11.9991 10.3991C11.5573 10.3991 11.1991 10.7572 11.1991 11.1991V15.1991C11.1991 15.6409 11.5573 15.9991 11.9991 15.9991ZM11.9991 9.59905C11.5573 9.59905 11.1991 9.24088 11.1991 8.79905C11.1991 8.35723 11.5573 7.99905 11.9991 7.99905C12.4409 7.99905 12.7991 8.35723 12.7991 8.79905C12.7991 9.24088 12.4409 9.59905 11.9991 9.59905Z",
    fill: "#0064CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.33549a321bffe1b3763d83be93ab8777.svg";
export { ForwardRef as ReactComponent };